import { render, staticRenderFns } from "./ORDsList.vue?vue&type=template&id=7b00ac25&"
import script from "./ORDsList.vue?vue&type=script&lang=js&"
export * from "./ORDsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports